<script>
	import Media from '../molecules/Media.svelte';
	import Text from '../atoms/text.svelte';
	import { getConnectorValue } from '../query';

	export let media = [];

	let connected = getConnectorValue();
</script>

<section>
	{#each media as elem, i}
		{#if connected || (!connected && i > 0)}
			<Media media={elem} maxValue={media.length} option={true} />
		{/if}
	{/each}
</section>

<style>
	section {
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
	}
</style>
